<template>
    <v-list-tile class="sidebar-profile">
        <v-list-tile-avatar>
            <img
                :src="`${baseImgPath}/static/avatars/user-13.jpg`"
                alt="avatar"
                height="40"
                width="40"
                class="img-responsive"
            />
        </v-list-tile-avatar>
        <v-list-tile-content class="ml-3">
            <v-list-tile-title
                ><span>{{ userName }}</span></v-list-tile-title
            >
        </v-list-tile-content>
        <v-menu
            bottom
            offset-y
            left
            content-class="userblock-dropdown"
            nudge-top="-10"
            nudge-right="0"
            transition="slide-y-transition"
        >
            <v-btn dark icon slot="activator" class="ma-0">
                <v-icon>more_vert</v-icon>
            </v-btn>
            <div class="dropdown-content">
                <div class="dropdown-top white--text primary">
                    <span class="white--text fs-14 fw-bold d-block">{{
                        userFullName
                    }}</span>
                    <span class="d-block fs-12 fw-light">{{ userEmail }}</span>
                </div>
                <v-list class="dropdown-list">
                    <template
                        v-for="userLink in userLinks"
                        v-if="userLink.id !== 4"
                    >
                        <v-list-tile
                            :to="getMenuLink(userLink.path)"
                            :key="userLink.id"
                        >
                            <i :class="userLink.icon"></i>
                            <span>{{ $t(userLink.title) }}</span>
                        </v-list-tile>
                    </template>
                    <template v-else>
                        <v-list-tile @click="logoutUser" :key="userLink.id">
                            <i :class="userLink.icon"></i>
                            <span>{{ $t(userLink.title) }}</span>
                        </v-list-tile>
                    </template>
                </v-list>
            </div>
        </v-menu>
    </v-list-tile>
</template>

<script>
import { getCurrentAppLayout } from 'Helpers/helpers'
import AppConfig from 'Constants/AppConfig'

export default {
    data() {
        return {
            baseImgPath: AppConfig.baseImgUrl,
            userLinks: [
                // {
                // 	id: 1,
                // 	title: 'message.userProfile',
                // 	icon: 'ti-user mr-3 primary--text',
                // 	path: '/users/profile'
                // },
                {
                    id: 4,
                    title: 'message.logOut',
                    icon: 'ti-power-off mr-3 error--text',
                },
            ],
            userEmail: null,
            userFullName: null,
            userName: null,
        }
    },
    mounted: function() {
        this.getUserData()
    },
    methods: {
        getUserData() {
            let user =
                typeof localStorage.getItem('user') !== 'undefined'
                    ? JSON.parse(localStorage.getItem('user'))
                    : null

            if (user != null) {
                this.userEmail = user.email
                this.userName = user.fullname
                this.userFullName = user.fullname
            }
        },
        logoutUser() {
            this.$store.dispatch('logoutUser', this.$router)
        },
        getMenuLink(path) {
            return '/' + getCurrentAppLayout(this.$router) + path
        },
    },
}
</script>
